const API_URL = {
  TOKEN: '/auth/token'
};

export default API_URL;
